import { core } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';
import {
  type FabricShareWxApi,
  type FabricShareWxCallbackData,
  type FabricShareWxOptions,
} from './types.js';

export const openShareWx: FabricShareWxApi = (
  options: FabricShareWxOptions
) => {
  return new Promise<FabricShareWxCallbackData>((resolve, reject) => {
    core.call<
      'fabric_share.showSocialSharePopup',
      FabricShareWxOptions,
      FabricShareWxCallbackData
    >('fabric_share.showSocialSharePopup', options, (result) => {
      const fabricErrors = filterFabricErrors(
        result.code,
        result.message,
        result.data
      );
      if (fabricErrors) {
        reject(fabricErrors);
      } else {
        resolve(result.data);
      }
    });
  });
};
